import { useNavigate } from 'react-router-dom';
import './CardWithBottomHeader.scss';
import { FC } from 'react';
import { useAppDispatch } from '../../redux/app/hooks';
import { setSelectedLibraryId, setSelectedSubjectId } from '../../redux/slices/dashboardSlice';
import images from '../../assets/images';


interface PropsType{
    image: any;
    title: string;
    bottomHeader: string;
    imageWidth: string;
    imageHeight: string;
    paddingBottom: string;
    navigateLocation: string;
    libraryId?: string;
    subId?: string;
    keyValue: string;
    active ? : boolean
}

const CardWithBottomHeader: FC<PropsType> = ({keyValue, libraryId, image, title, bottomHeader,imageWidth, imageHeight, paddingBottom, navigateLocation,subId,active}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {  redDotImage } = images;
    
    const onClickCard = () => {
        if (libraryId) {
            dispatch(setSelectedLibraryId({ selectedLibraryId: libraryId }));
        }
        if (subId) {
            dispatch(setSelectedSubjectId({ selectedSubjectId: subId }));
        }
        navigate(navigateLocation, { state: { title, imageSrc: image } });
    }

  return (
    <div className={subId ? 'cardWithBottomHeaderMainContainer' : 'cardWithBottomHeaderMainContainer mylibraryWithCardMobile'} onClick={onClickCard}>
            <div className='cardContainer'>
            {( active) && <img src={redDotImage} className='redDotStyle' alt='redDotImage'/>}
                <div className='imageContainer'>
                    <img 
                        src={image}
                        alt='cardImage'
                        className='cardImageStyle'
                        style={{
                            width: imageWidth,
                            height: imageHeight,
                            paddingBottom
                        }}
                    />
                </div>
                <div className='bottomHeaderContainer'>
                    {bottomHeader}
                </div>
            </div>
            <div className='cardTitleContainer'>{title}</div>
    </div>
  )
}

export default CardWithBottomHeader
